import keyMirror from '../helpers/keymirror';

export const AUTHENTICATE_SOCKET = 'AUTHENTICATE_SOCKET';
export const AUTH_CHANNEL_RETRY = 'AUTH_CHANNEL_RETRY';
export const CONNECT_SOCKET = 'CONNECT_SOCKET';
export const SOCKET_CONNECTED = 'SOCKET_CONNECTED';
export const PUBLIC_SOCKET_CONNECTED = 'PUBLIC_SOCKET_CONNECTED';
export const CONNECT_PUBLIC_SOCKET = 'CONNECT_PUBLIC_SOCKET';
export const DISCONNECT_PUBLIC_SOCKET = 'DISCONNECT_PUBLIC_SOCKET';
export const ENABLE_HEARTBEAT_PUBLIC = 'ENABLE_HEARTBEAT_PUBLIC';
export const CHECK_HEARTBEAT_PUBLIC = 'CHECK_HEARTBEAT_PUBLIC';
export const DISABLE_HEARTBEAT_PUBLIC = 'DISABLE_HEARTBEAT_PUBLIC';
export const DISCONNECT_SOCKET = 'DISCONNECT_SOCKET';
export const RECONNECT_SOCKET = 'RECONNECT_SOCKET';
export const ACTIVATE_POLLING = 'ACTIVATE_POLLING';
export const DEACTIVATE_POLLING = 'DEACTIVATE_POLLING';
export const MANUAL_POLLING_ACTIVATE = 'MANUAL_POLLING_ACTIVATE';
export const CONNECT_SELECTED_PRODUCT_CHANNEL = 'CONNECT_SELECTED_PRODUCT_CHANNEL';
export const CONNECT_SELECTED_PRODUCT_CHANNEL_PUBLIC =
  'CONNECT_SELECTED_PRODUCT_CHANNEL_PUBLIC';

export const RECONNECT_SOCKET_TAB_REACTIVE = 'RECONNECT_SOCKET_TAB_REACTIVE';

export const ENABLE_HEARTBEAT = 'ENABLE_HEARTBEAT';
export const DISABLE_HEARTBEAT = 'DISABLE_HEARTBEAT';
export const CHECK_HEARTBEAT = 'CHECK_HEARTBEAT';

// export const UPDATE_HEARTBEAT_TS = 'UPDATE_HEARTBEAT_TS';

export const SUBSCRIBE_FUNDING = 'SUBSCRIBE_FUNDING';
export const UNSUBSCRIBE_FUNDING = 'UNSUBSCRIBE_FUNDING';
export const SUBSCRIBE_L2_ORDERBOOK = 'SUBSCRIBE_L2_ORDERBOOK';
export const UNSUBSCRIBE_L2_ORDERBOOK = 'UNSUBSCRIBE_L2_ORDERBOOK';
export const SUBSCRIBE_BEST_BID_BEST_ASK = 'SUBSCRIBE_BEST_BID_BEST_ASK';
export const UNSUBSCRIBE_BEST_BID_BEST_ASK = 'UNSUBSCRIBE_BEST_BID_BEST_ASK';
export const SUBSCRIBE_MARK = 'SUBSCRIBE_MARK';
export const SUBSCRIBE_TRADING_NOTIFICATIONS = 'SUBSCRIBE_TRADING_NOTIFICATIONS';
export const SUBSCRIBE_ORDERS = 'SUBSCRIBE_ORDERS';
export const SUBSCRIBE_PUBLIC_CHANNELS = 'SUBSCRIBE_PUBLIC_CHANNELS';
export const SUBSCRIBE_RECENT_TRADE = 'SUBSCRIBE_RECENT_TRADE';
export const SUBSCRIBE_SPOT = 'SUBSCRIBE_SPOT';
export const UNSUBSCRIBE_SPOT = 'UNSUBSCRIBE_SPOT';
export const SUBSCRIBE_TICKER = 'SUBSCRIBE_TICKER';
export const UNSUBSCRIBE_TICKER = 'UNSUBSCRIBE_TICKER';
export const SUBSCRIBE_OHLC_CANDEL = 'SUBSCRIBE_OHLC_CANDEL';
export const UNSUBSCRIBE_OHLC_CANDEL = 'UNSUBSCRIBE_OHLC_CANDEL';
export const SUBSCRIBE_MARGIN = 'SUBSCRIBE_MARGIN';

export const UNSUBSCRIBE_ALL = 'UNSUBSCRIBE_ALL';
export const UNSUBSCRIBE_OB_RT = 'UNSUBSCRIBE_OB_RT';
export const UNSUBSCRIBE_PRIVATE = 'UNSUBSCRIBE_PRIVATE';

export const SUBSCRIBE_SELECTED_PRODUCT_MARK_DATA =
  'SUBSCRIBE_SELECTED_PRODUCT_MARK_DATA';
export const UNSUBSCRIBE_SELECTED_PRODUCT_MARK_DATA =
  'UNSUBSCRIBE_SELECTED_PRODUCT_MARK_DATA';

export const SUBSCRIBE_SELECTED_PRODUCT_SPOT = 'SUBSCRIBE_SELECTED_PRODUCT_SPOT';
export const UNSUBSCRIBE_SELECTED_PRODUCT_SPOT = 'UNSUBSCRIBE_SELECTED_PRODUCT_SPOT';

export const SUBSCRIBE_WALLET_SPOT = 'SUBSCRIBE_WALLET_SPOT';
export const UNSUBSCRIBE_WALLET_SPOT = 'UNSUBSCRIBE_WALLET_SPOT';
export const SUBSCRIBE_OPEN_POSITION_SPOT = 'SUBSCRIBE_OPEN_POSITION_SPOT';
export const UNSUBSCRIBE_OPEN_POSITION_SPOT = 'UNSUBSCRIBE_OPEN_POSITION_SPOT';

export const SUBSCRIBE_OPEN_POSITION_MARK = 'SUBSCRIBE_OPEN_POSITION_MARK';
export const UNSUBSCRIBE_MARK = 'UNSUBSCRIBE_MARK';

export const SUBSCRIBE_OPTION_CHAIN_MARK = 'SUBSCRIBE_OPTION_CHAIN_MARK';
export const UNSUBSCRIBE_OPTION_CHAIN_MARK = 'UNSUBSCRIBE_OPTION_CHAIN_MARK';

export const SUBSCRIBE_EASY_OPTIONS_ORDERBOOK = 'SUBSCRIBE_EASY_OPTIONS_ORDERBOOK';
export const UNSUBSCRIBE_EASY_OPTIONS_ORDERBOOK = 'UNSUBSCRIBE_EASY_OPTIONS_ORDERBOOK';

export const SUBSCRIBE_CONTRACT_ALL_RECENT_TRADES =
  'SUBSCRIBE_CONTRACT_ALL_CONTRACTS_RECENT_TRADES';
export const UNSUBSCRIBE_CONTRACT_ALL_RECENT_TRADES =
  'UNSUBSCRIBE_CONTRACT_ALL_CONTRACTS_RECENT_TRADES';

const actionTypes = keyMirror({
  IS_CONNECTED: null,
});

export const UPDATE_HEARTBEAT = 'UPDATE_HEARTBEAT';

export const SUBSCRIBE_PRICE_ALERT_COIN_SPOT = 'SUBSCRIBE_PRICE_ALERT_COIN_SPOT';
export const UNSUBSCRIBE_PRICE_ALERT_COIN_SPOT = 'UNSUBSCRIBE_PRICE_ALERT_COIN_SPOT';

export default actionTypes;
